import { createAction } from '@reduxjs/toolkit';

const NAMESPACE = 'app/navigate';

const push = createAction<string>(`${NAMESPACE}/checkAuth`);
const replace = createAction<string>(`${NAMESPACE}/replace`);

export { push, replace };
